import './Report.css'

const Report = ({onClick, image, title, topic, other, description, available}) => {
    return (
        <div className={available ? 'report-container' : 'report-container not-available-report'}>
            <img className={available ? 'report-image' : 'report-image not-available-image'} src={image} alt='report-first-page'></img>
            <div className='report-text-content'>
                <div className='report-title-topic-date-container'>
                    <div className='report-title-date-container'>
                        <span className='report-title'>{title}</span>
                    </div>
                    <span className='report-topic'>{topic === 'Other' ? other : topic}</span>
                </div>
                <span className='report-description'>{description}</span>
                <span 
                    className={available ? 'report-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Review Report' : 'Coming soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Report